"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _command = _interopRequireDefault(require("@ckeditor/ckeditor5-core/src/command"));

var _toarray = _interopRequireDefault(require("@ckeditor/ckeditor5-utils/src/toarray"));

var _filerepository = _interopRequireDefault(require("@ckeditor/ckeditor5-upload/src/filerepository"));

var _uuid = require("uuid");

var _strings = require("../../../../util/strings");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var GrooveImageUploadCommand = /*#__PURE__*/function (_Command) {
  (0, _inherits2["default"])(GrooveImageUploadCommand, _Command);

  var _super = _createSuper(GrooveImageUploadCommand);

  function GrooveImageUploadCommand() {
    (0, _classCallCheck2["default"])(this, GrooveImageUploadCommand);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(GrooveImageUploadCommand, [{
    key: "refresh",

    /**
     * @inheritDoc
     */
    value: function refresh() {
      var imageUtils = this.editor.plugins.get('ImageUtils');
      var imageElement = this.editor.model.document.selection.getSelectedElement();
      var isImage = imageElement && imageElement.name === 'image' || false;
      this.isEnabled = imageUtils.isImageAllowed(this.editor.model) || isImage;
    }
    /**
     * Executes the command.
     *
     * @fires execute
     * @param {Object} options Options for the executed command.
     * @param {File|Array.<File>} options.file The image file or an array of image files to upload.
     */

  }, {
    key: "execute",
    value: function execute(options) {
      var _this = this;

      var editor = this.editor;
      var selection = editor.model.document.selection;
      var imageUtils = this.editor.plugins.get('ImageUtils');

      var _editor$config$get = editor.config.get('grooveImagePluginConfig'),
          EDITOR_MAX_INLINE_IMAGE_SIZE = _editor$config$get.EDITOR_MAX_INLINE_IMAGE_SIZE,
          EDITOR_MAX_UPLOAD_SIZE = _editor$config$get.EDITOR_MAX_UPLOAD_SIZE,
          onInlineImageTooLarge = _editor$config$get.onInlineImageTooLarge,
          onFileTooLarge = _editor$config$get.onFileTooLarge; // In case of multiple files, each file (starting from the 2nd) will be inserted at a position that
      // follows the previous one. That will move the selection and, to stay on the safe side and make sure
      // all images inherit the same selection attributes, they are collected beforehand.
      //
      // Applying these attributes ensures, for instance, that inserting an (inline) image into a link does
      // not split that link but preserves its continuity.
      //
      // Note: Selection attributes that do not make sense for images will be filtered out by insertImage() anyway.


      var selectionAttributes = Object.fromEntries(selection.getAttributes());
      (0, _toarray["default"])(options.file).forEach(function (file, index) {
        if (file.size >= EDITOR_MAX_UPLOAD_SIZE) {
          onFileTooLarge(function (prevAttachments) {
            return [].concat((0, _toConsumableArray2["default"])(prevAttachments), [{
              error: "Attachment too large (max size ".concat((0, _strings.humanFileSize)(EDITOR_MAX_UPLOAD_SIZE), ")"),
              id: (0, _uuid.v4)(),
              name: file.name,
              type: file.type,
              size: file.size
            }]);
          });
        } else if (file.size > EDITOR_MAX_INLINE_IMAGE_SIZE) {
          onInlineImageTooLarge((0, _uuid.v4)(), file);
        } else {
          var selectedElement = selection.getSelectedElement(); // Inserting of an inline image replace the selected element and make a selection on the inserted image.
          // Therefore inserting multiple inline images requires creating position after each element.

          if (index && selectedElement && imageUtils.isImage(selectedElement)) {
            var position = _this.editor.model.createPositionAfter(selectedElement);

            _this._uploadImage(file, selectionAttributes, position);
          } else {
            _this._uploadImage(file, selectionAttributes);
          }
        }
      });
    } // Handles uploading single file.
    //
    // @param {module:engine/model/model~Model} model
    // @param {File} file

  }, {
    key: "_uploadImage",
    value: function _uploadImage(file, attributes, position) {
      var plugins = this.editor.plugins;
      var fileRepository = plugins.get(_filerepository["default"]);
      var imageUtils = plugins.get('ImageUtils');
      var loader = fileRepository.createLoader(file); // Do not throw when upload adapter is not set. FileRepository will log an error anyway.

      if (!loader) {
        return;
      }

      imageUtils.insertImage(_objectSpread(_objectSpread({}, attributes), {}, {
        uploadId: loader.id,
        customClass: 'grv-figure-image',
        customImgClass: 'grv-inline-image',
        customDataOriginalFilename: file.name
      }), position);
    }
  }]);
  return GrooveImageUploadCommand;
}(_command["default"]);

exports["default"] = GrooveImageUploadCommand;
//# sourceMappingURL=grooveimagecommand.js.map